import { Action, createReducer, on } from '@ngrx/store';
import * as NoteActions from 'src/app/recruiting/candidates/new-profile/notes-and-activities/store/notes.actions';
import { NotesState } from 'src/app/recruiting/candidates/new-profile/notes-and-activities/store/notes.state';

export const initialState: NotesState = {
    loading: false,
    notesAndActivities: [],
    orientationNotes: [],
    error: undefined,
    addingNote: false,
    candidateId: null,
    limitHistory: false
};

const reducer = createReducer(
    initialState,

    on(NoteActions.loadNotesAndActivities, (state) => ({
        ...state,
        loading: true
    })),

    on(NoteActions.loadNotesAndActivitiesSuccess, (state, action) => ({
        ...state,
        loading: false,
        notesAndActivities: action.notesAndActivities,
        orientationNotes: action.orientationNotes,
        candidateId: action.candidateId,
        limitHistory: action.limitHistory
    })),

    on(NoteActions.loadNotesAndActivitiesFailure, (state, action) => ({
        ...state,
        loading: false,
        notesAndActivities: [],
        error: action.error
    })),

    on(NoteActions.loadRecruiterAssignmentSuccess, (state, action) => ({
        ...state,
        loading: false,
        notesAndActivities: [...action.notesAndActivities].sort((a, b) =>
            new Date(a.noteDateTime).getTime() > new Date(b.noteDateTime).getTime() ? -1 : 1
        ),
        orientationNotes: action.orientationNotes,
        candidateId: action.candidateId,
        limitHistory: action.limitHistory
    })),

    on(NoteActions.loadRecruiterAssignmentFailure, (state, action) => ({
        ...state,
        loading: false,
        notesAndActivities: [],
        error: action.error
    })),

    on(NoteActions.addNotesAndActivities, (state) => ({
        ...state,
        addingNote: true,
        loading: true
    })),

    on(NoteActions.pinProfileNote, (state) => ({
        ...state,
        loading: true
    })),

    on(NoteActions.pinProfileNoteSuccess, (state, action) => ({
        ...state,
        notesAndActivities: state.notesAndActivities.map((note) =>
            note.noteId === action.notePin.noteId &&
            note.noteTypeId === action.notePin.noteTypeId &&
            note.noteSourceTypeId === action.notePin.noteSourceTypeId
                ? {
                      ...note,
                      isPinned: true,
                      notePinId: action.notePin.notePinId,
                      pinnedBy: action.notePin.pinnedBy,
                      pinnedDateUTC: action.notePin.pinnedDateUTC
                  }
                : note
        ),
        loading: false
    })),

    on(NoteActions.pinProfileNoteFailure, (state, action) => ({
        ...state,
        error: action.error,
        loading: false
    })),

    on(NoteActions.unpinProfileNote, (state) => ({
        ...state,
        loading: true
    })),

    on(NoteActions.unpinProfileNoteSuccess, (state, action) => ({
        ...state,
        notesAndActivities: state.notesAndActivities.map((note) =>
            note.notePinId === action.notePinId
                ? {
                      ...note,
                      isPinned: false,
                      notePinId: null,
                      pinnedBy: null,
                      pinnedDateUTC: null
                  }
                : note
        ),
        loading: false
    })),

    on(NoteActions.unpinProfileNoteFailure, (state, action) => ({
        ...state,
        error: action.error,
        loading: false
    })),

    on(NoteActions.addSectionNote, (state) => ({
        ...state,
        addingNote: true,
        loading: true
    })),

    on(NoteActions.addNotesAndActivitiesSuccess, (state, action) => ({
        ...state,
        addingNote: false,
        notesAndActivities: [action.returnNote, ...state.notesAndActivities],
        loading: false
    })),

    on(NoteActions.addSectionNoteSuccess, (state, action) => ({
        ...state,
        addingNote: false,
        notesAndActivities: [action.note, ...state.notesAndActivities],
        orientationNotes: [action.orientationNote, ...state.orientationNotes],
        loading: false
    })),

    on(NoteActions.addNotesAndActivitiesFailure, (state, action) => ({
        ...state,
        addingNote: false,
        error: action.error,
        loading: false
    }))
);

export function notesReducer(state: NotesState | undefined, action: Action) {
    return reducer(state, action);
}
